import { Branding as ApiBranding, PortalSettings as ApiPortalSettings } from '@/types/index'

type Branding = ApiBranding & {
  portalType: PortalType
  hasGuestQuotes: boolean
  supplierPortalLoginUrl?: string
}

enum PortalType {
  EssentialPortal = 'EssentialPortal',
  FullPortal = 'FullPortal',
  QuotesPortal = 'QuotesPortal',
  SupplierPortal = 'SupplierPortal'
}

type PortalSettings = ApiPortalSettings & {
  clearBrowserSession?: boolean
  hideColleaguesPermissions?: boolean
  showPaymentMethodSelection?: boolean
  hideProfile?: boolean
  useCollections: boolean
  useOrders: boolean
  minimumOrderSurchargesOnlyApplyOncePerCart: boolean
  platformCartLink?: string
  backToPlatformLink?: string
  loginLink?: string
  useTopi?: boolean
}

type LoginFooter = {
  ownerName: string
  legalInfoUrl?: string
  privacyUrl?: string
  termsUrl?: string
}

type PortalTypeConfig = {
  portalLayoutType: PortalLayoutType
  hasGuestQuotes: boolean
}

enum PortalLayoutType {
  QUOTES_PORTAL_LAYOUT = 'QUOTES_PORTAL_LAYOUT',
  DEFAULT_LAYOUT = 'DEFAULT_LAYOUT',
  PORTAL_UNAVAILABLE_LAYOUT = 'PORTAL_UNAVAILABLE_LAYOUT'
}

export { Branding, LoginFooter, PortalLayoutType, PortalSettings, PortalType, PortalTypeConfig }
